export default {
  SIMPLE_HSL: 'simple_hsl',
  SIMPLE_HSLA: 'simple_hsla',
  BLOCK_BACKGROUND_LAYER: 'block_background_layer',
  LINK: 'link',
  INPUT_BORDER: 'input_border',
  SOCIAL_ICON: 'social_icon',
  PRIMARY_BUTTON_SURFACE: 'primary_button_surface',
  PRIMARY_BUTTON_TEXT: 'primary_button_text',
  SECONDARY_BUTTON_SURFACE: 'secondary_button_surface',
  SECONDARY_BUTTON_TEXT: 'secondary_button_text',
};
